module.exports = __webpack_public_path__ + "static/img/green.6f4ff3b.gif";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/green.gif
// module id = z7pN
// module chunks = 1